import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class Type extends Field {
  static attributesForModel(modelClass) {
    if (modelClass.typename === 'ReleasePhase') {
      return ['type'];
    }

    return [];
  }

  get title() {
    return 'Type';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Milestone' };
  }

  contentsForRecord(record): FieldContentsData {
    return { text: record.type };
  }
}
